import { useEffect, useState } from "react";

import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { Endpoints } from "./Endpoints";
import { UploadFilesResponse } from "./Responses";
interface RequestOptions {
  method: "POST" | "GET" | "PUT" | "DELETE";
  url: string;
  body?: any;
}
function usePerformRequest<Type>({ method, url, body }: RequestOptions) {
  const [data, setData] = useState<Type>();
  const [response, setResponse] = useState<AxiosResponse>();
  const [error, setError] = useState<AxiosError>();
  const [status, setStatus] = useState<number | string>("undefined");
  const [isLoading, setLoading] = useState<boolean>(false);
  const reloadData = async () => {
    const token = Cookies.get("token");
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `${token}`,
      },
      method,
      data: body,
      url,
    };
    setLoading(true);
    const r: any = await axios.request(config).catch((e: AxiosError) => {
      setError(e);
      setStatus(e.response?.status as number);

      return {
        status: e.response?.status,
      };
    });
    setResponse(r as AxiosResponse);
    setStatus(r.status);
    setLoading(false);
    setData(r?.data ?? undefined);
  };
  useEffect(() => {
    reloadData().catch(() => setLoading(false));
  }, [url]);

  return { data, response, isLoading, reloadData, status, error };
}

interface PerformRequestOptions {
  method: "POST" | "PATCH" | "GET" | "PUT" | "DELETE";
  data?: any;
  route: string;
  headers?: any;
  doNotUseAuthorization?: boolean;
}

async function PerformRequest<Type>({
  method,
  data,
  route,
  headers,
  doNotUseAuthorization,
}: PerformRequestOptions) {
  const token = Cookies.get("token");

  const requestHeaders = doNotUseAuthorization
    ? { ...headers }
    : { Authorization: `${token}`, ...headers };
  const config = {
    method,
    data,
    url: route,
    headers: requestHeaders,
  };

  const r: any = await axios.request(config).catch((e: AxiosError) => {
    return {
      status: e.response?.status,
      message: (e?.response?.data as any)?.message,
      data: (e?.response?.data as any)?.data,
    };
  });
  return {
    status: r.status as number,
    data: r?.data as Type,
    message: r?.message ?? undefined,
  };
}

const UploadFiles = async (files: File[]) => {
  let data = new FormData();
  files.map((f) => {
    data.append("files", f);
  });
  const config: AxiosRequestConfig = {
    method: "post",
    maxBodyLength: Infinity,
    url: Endpoints.UploadFile,
    data,
  };
  const r = await axios.request(config);
  const { data: response, status } = r;
  return {
    status,
    data: response.data,
    message: response.message,
  } as UploadFilesResponse;
};
export { usePerformRequest, PerformRequest, UploadFiles };
